import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

// layouts
import { AdminComponent } from "../../layouts/admin/admin.component";

// admin views
import { DashboardComponent } from "./dashboard/dashboard.component";
import { AccountInfoComponent } from "./account-info/account-info.component";
import { AppointmentListComponent } from "./appointment-list/appointment-list.component";
import { UserWalletComponent } from "./user-wallet/user-wallet.component";
import { MessageComponent } from "./message/message.component";
import { ChatComponent } from "./chat/chat.component";
import { AuthGuard } from "src/app/shared/guards/auth.guard";
import { FinancialRequestsComponent } from "./financial-requests/financial-requests.component";
import { autoLoginPartialRoutesGuard } from "angular-auth-oidc-client";

export const UserLayoutRoutes: Routes = [
      // { path: "", component: DashboardComponent},
      // {
      //       path: '',
      //       pathMatch: 'full',
      //       redirectTo: '/user/dashboard',
      // },
      { path: "dashboard", component: DashboardComponent },
      { path: "account", component: AccountInfoComponent, canActivate: [autoLoginPartialRoutesGuard]},
      { path: "appointment", component: AppointmentListComponent, canActivate: [autoLoginPartialRoutesGuard],},
      { path: "wallet", component: UserWalletComponent, canActivate: [autoLoginPartialRoutesGuard],},
      { path: "message", component: MessageComponent, canActivate: [autoLoginPartialRoutesGuard],},
      { path: "chat/:visitId", component: ChatComponent, canActivate: [autoLoginPartialRoutesGuard],},
      { path: "requests", component: FinancialRequestsComponent, canActivate: [autoLoginPartialRoutesGuard],},
      // { path: "", redirectTo: "dashboard", pathMatch: "full" },
];
